import React, { useState, useRef, useEffect } from 'react'
import Style from './tabs.module.scss'
import { CloseOutlined } from '@ant-design/icons'
import { userRouter } from '../../route'
import { history, useTypedSelector } from '../../redux/store'
import {
  checkTabsAction,
  addTabsAction,
  tabsParam,
  delTabsAction,
  resetTabsAction,
  delOtherTabsAction,
  setCurrentRightTabAction,
  updateTabSearchAction,
} from '../../modules/authtoken'
import { useDispatch } from 'react-redux'
import { Divider, Dropdown, MenuProps } from 'antd'
import { delRouterAction, resetRouterAction } from '../../modules/routerModules'
import {
  delModuleDataAction,
  resetModuleDataAction,
  resetFormDataAction,
} from '../../modules/pagecache'
import { setformStateInitAction } from '../../modules/ControlformState'
import { useAliveController } from 'react-activation'
// 自定义tabs 页签
const Customtabs = () => {
  const [scrollx, setScrollx] = useState<number>(0)
  const { tabsData, tabsActive, currentRightTab } = useTypedSelector(
    (state) => state.authtoken,
  )
  const { routerList } = useTypedSelector((state) => state.routerModules)
  const dispatch = useDispatch()
  const { clear, drop } = useAliveController()
  const supRoute = userRouter[1].url
  const ref = useRef<HTMLDivElement>(null)
  const itemRef = useRef<HTMLDivElement>(null)
  const isInitial = useRef<boolean>(true)
  useEffect(() => {
    if (tabsData.length === 0) {
      // 刷新返回首页 清空redux  tabs 数据
      onClickDelall()
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    const { pathname, search } = history.location
    if (tabsData.length === 0 && pathname === `${supRoute}/home`) {
      return
    }
    if (isInitial.current) {
      isInitial.current = false
    }
    const item = routerList.filter((item) => supRoute + item.url === pathname)
    if (item.length === 1) {
      matchrouter(pathname, search)
    } else {
      history.replace('/notFound')
    }
    // eslint-disable-next-line
  }, [history.location.pathname, tabsData.length])
  useEffect(() => {
    if (itemRef.current) {
      itemRef.current.scrollIntoView(false)
    }
    // eslint-disable-next-line
  }, [tabsActive])

  // 匹配路由
  async function matchrouter(pathname: string, search: string) {
    // 获取对应的路由item
    const routeritem = routerList.filter((i) => supRoute + i.url === pathname)
    // 筛选
    const tabkey = tabsData.filter((item) => item.url === pathname)
    dispatch(checkTabsAction(pathname))

    if (tabkey.length === 0 && pathname !== '/srm/home') {
      // 新增页签
      const item = routeritem[0]
      dispatch(
        addTabsAction({
          title: item.title,
          keyName: item.keyName,
          key: item.key,
          url: pathname,
          search: search,
        }),
      )
    } else if (
      tabkey.length === 1 &&
      routeritem[0]?.refreshOnQueryChange &&
      tabkey[0].search !== search
    ) {
      // 同一详情页打开了另一张单据:清缓存强制重新取数 + 刷新页签参数
      const item = routeritem[0]
      if (item.cache) {
        await drop(item.key)
      }
      dispatch(updateTabSearchAction({ key: tabkey[0].key, search }))
    }
  }

  // 滚轮事件
  function onWheel(event: React.WheelEvent<HTMLDivElement>) {
    // 滚动距离
    const scrollLeft = ref.current?.scrollLeft || 0
    // 元素总宽度
    const divWidth = ref.current?.scrollWidth || 0
    // 可见区域宽度
    const clientWidth = ref.current?.clientWidth || 0
    // 滚动间距
    const scrollIndex = 50
    if (event.deltaY < 0) {
      // 向左
      if (scrollLeft <= 0 && ref.current) {
        setScrollx(0)
        ref.current.scrollLeft = 0
        return false
      }
      const s = scrollx - scrollIndex
      setScrollx(s)
      if (ref.current) {
        ref.current.scrollLeft = s
      }
    } else {
      // 向右
      if (clientWidth + scrollLeft >= divWidth) {
        return false
      }
      const s = scrollx + scrollIndex
      setScrollx(s)
      if (ref.current) {
        ref.current.scrollLeft = s
      }
    }
  }

  // 滚动事件
  function onScroll(event: React.UIEvent<HTMLDivElement, UIEvent>) {
    const left = event.currentTarget.scrollLeft
    setScrollx(left)
  }

  // 返回首页
  function onClickHome() {
    if (tabsActive === 'home') {
      return false
    }
    history.replace(`${supRoute}/home`)
  }

  // 选中页签
  function onClickTabs(
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    info: tabsParam,
  ) {
    e.stopPropagation()
    e.preventDefault()
    switchTab(info)
  }
  function switchTab(info: tabsParam) {
    // 已选中不可跳转
    if (tabsActive === info.url) {
      return false
    }
    history.replace(info.url + info.search)
  }
  // 删除页签
  function oncloseTabs(
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    info: tabsParam,
  ) {
    e.preventDefault()
    e.stopPropagation()
    closeTab(info)
  }
  async function closeTab(info: tabsParam) {
    // 防止undefined导致程序bug
    if (!info) {
      return
    }
    let newurl = ''
    if (tabsData.length === 1) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    if (tabsData.length > 1) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === info.url) {
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = tabsData[param]?.search ? url + tabsData[param].search : url
    }
    // 删除标签 删除 对应路由 删除缓存数据
    dispatch(delTabsAction(info.key))
    dispatch(delRouterAction(info.key))
    dispatch(delModuleDataAction(info.url))
    if (tabsActive === info.url) {
      // 若删除当前激活页签后 需跳转至前一个
      history.replace(newurl)
    }
    // 清除对应的KeepAlive缓存
    await drop(info.key)
  }
  // 清除所有tabs
  async function onClickDelall() {
    history.replace('/srm/home')
    dispatch(resetTabsAction())
    dispatch(resetRouterAction())
    dispatch(resetModuleDataAction())
    dispatch(resetFormDataAction())
    dispatch(setformStateInitAction())
    await clear()
  }
  type MenuName = '关闭' | '关闭其他' | '关闭所有'
  const handleRightMenuClick: MenuProps['onClick'] = async (e) => {
    const currentItem = tabsData.filter((item) => {
      return item.url === tabsActive
    })?.[0]
    // const  res
    switch (e.key) {
      case '关闭':
        closeTab(currentRightTab ?? currentItem)
        break
      case '关闭所有':
        onClickDelall()
        break
      case '关闭其他':
        switchTab(currentRightTab ?? currentItem)
        dispatch(delOtherTabsAction(currentRightTab?.key ?? ''))
        tabsData.forEach(async (item) => {
          if (currentRightTab?.key !== item.key) {
            dispatch(delModuleDataAction(item.url))
            // 清除对应的KeepAlive缓存
            await drop(item.key)
          }
        })
        break
    }
  }
  const menulist: MenuName[] = ['关闭', '关闭其他', '关闭所有']

  const items = menulist.map((item) => ({
    label: item,
    key: item,
  }))

  function handleRightMenuChange(info: tabsParam) {
    dispatch(setCurrentRightTabAction(info))
  }
  return (
    <div className={Style.tabContainer}>
      <div
        className={`${Style.tabsHome} ${
          tabsActive === '/srm/home' ? Style.tabActive : ''
        }`}
        onClick={onClickHome}
      >
        {/* <img style={{width: '20px',height: '20px'}} src={logoOn} alt='' /> */}
        <span>工作台</span>
      </div>
      <div
        className={Style.tabsBox}
        ref={ref}
        onWheel={onWheel}
        onScroll={onScroll}
      >
        {tabsData.map((item, index) => (
          <Dropdown
            key={item.key}
            menu={{
              items,
              onClick: handleRightMenuClick,
            }}
            trigger={['contextMenu']}
            placement="bottomLeft"
            getPopupContainer={() => document.body}
            onOpenChange={(visible) => {
              if (visible) {
                handleRightMenuChange(item)
              }
            }}
          >
            <div key={item.key}>
              {index !== 0 ? (
                <Divider
                  type="vertical"
                  style={{ backgroundColor: '#ffffff', opacity: 0.2 }}
                />
              ) : null}
              <div
                className={`${Style.tabItem} ${
                  tabsActive === item.url ? Style.tabActive : ''
                }`}
                onClick={(e) => onClickTabs(e, item)}
                ref={tabsActive === item.key ? itemRef : null}
              >
                <div className={Style['tabItem-inner']}>
                  {item.title}
                  <CloseOutlined
                    className={Style.icon}
                    onClick={(e) => oncloseTabs(e, item)}
                  />
                </div>
              </div>
            </div>
          </Dropdown>
        ))}
      </div>
      {tabsData.length > 0 ? (
        <div className={Style.tabsTool} onClick={onClickDelall}>
          清除
        </div>
      ) : null}
    </div>
  )
}

export default Customtabs
import React, { useState, useRef, useEffect } from 'react'
import Style from './tabs.module.scss'
import { CloseOutlined } from '@ant-design/icons'
import { userRouter } from '../../route'
import { history, useTypedSelector } from '../../redux/store'
import {
  checkTabsAction,
  addTabsAction,
  tabsParam,
  delTabsAction,
  resetTabsAction,
  delOtherTabsAction,
  setCurrentRightTabAction,
  updateTabSearchAction,
} from '../../modules/authtoken'
import { useDispatch } from 'react-redux'
import { Divider, Dropdown, MenuProps } from 'antd'
import { delRouterAction, resetRouterAction } from '../../modules/routerModules'
import {
  delModuleDataAction,
  resetModuleDataAction,
  resetFormDataAction,
} from '../../modules/pagecache'
import { setformStateInitAction } from '../../modules/ControlformState'
import { useAliveController } from 'react-activation'
// 自定义tabs 页签
const Customtabs = () => {
  const [scrollx, setScrollx] = useState<number>(0)
  const { tabsData, tabsActive, currentRightTab } = useTypedSelector(
    (state) => state.authtoken,
  )
  const { routerList } = useTypedSelector((state) => state.routerModules)
  const dispatch = useDispatch()
  const { clear, drop } = useAliveController()
  const supRoute = userRouter[1].url
  const ref = useRef<HTMLDivElement>(null)
  const itemRef = useRef<HTMLDivElement>(null)
  const isInitial = useRef<boolean>(true)
  useEffect(() => {
    if (tabsData.length === 0) {
      // 刷新返回首页 清空redux  tabs 数据
      onClickDelall()
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    const { pathname, search } = history.location
    if (tabsData.length === 0 && pathname === `${supRoute}/home`) {
      return
    }
    if (isInitial.current) {
      isInitial.current = false
    }
    const item = routerList.filter((item) => supRoute + item.url === pathname)
    if (item.length === 1) {
      matchrouter(pathname, search)
    } else {
      history.replace('/notFound')
    }
    // eslint-disable-next-line
  }, [history.location.pathname, tabsData.length])
  useEffect(() => {
    if (itemRef.current) {
      itemRef.current.scrollIntoView(false)
    }
    // eslint-disable-next-line
  }, [tabsActive])

  // 匹配路由
  async function matchrouter(pathname: string, search: string) {
    // 获取对应的路由item
    const routeritem = routerList.filter((i) => supRoute + i.url === pathname)
    // 筛选
    const tabkey = tabsData.filter((item) => item.url === pathname)
    dispatch(checkTabsAction(pathname))

    if (tabkey.length === 0 && pathname !== '/srm/home') {
      // 新增页签
      const item = routeritem[0]
      dispatch(
        addTabsAction({
          title: item.title,
          keyName: item.keyName,
          key: item.key,
          url: pathname,
          search: search,
        }),
      )
    } else if (
      tabkey.length === 1 &&
      routeritem[0]?.refreshOnQueryChange &&
      tabkey[0].search !== search
    ) {
      // 同一详情页打开了另一张单据:清缓存强制重新取数 + 刷新页签参数
      const item = routeritem[0]
      if (item.cache) {
        await drop(item.key)
      }
      dispatch(updateTabSearchAction({ key: tabkey[0].key, search }))
    }
  }

  // 滚轮事件
  function onWheel(event: React.WheelEvent<HTMLDivElement>) {
    // 滚动距离
    const scrollLeft = ref.current?.scrollLeft || 0
    // 元素总宽度
    const divWidth = ref.current?.scrollWidth || 0
    // 可见区域宽度
    const clientWidth = ref.current?.clientWidth || 0
    // 滚动间距
    const scrollIndex = 50
    if (event.deltaY < 0) {
      // 向左
      if (scrollLeft <= 0 && ref.current) {
        setScrollx(0)
        ref.current.scrollLeft = 0
        return false
      }
      const s = scrollx - scrollIndex
      setScrollx(s)
      if (ref.current) {
        ref.current.scrollLeft = s
      }
    } else {
      // 向右
      if (clientWidth + scrollLeft >= divWidth) {
        return false
      }
      const s = scrollx + scrollIndex
      setScrollx(s)
      if (ref.current) {
        ref.current.scrollLeft = s
      }
    }
  }

  // 滚动事件
  function onScroll(event: React.UIEvent<HTMLDivElement, UIEvent>) {
    const left = event.currentTarget.scrollLeft
    setScrollx(left)
  }

  // 返回首页
  function onClickHome() {
    if (tabsActive === 'home') {
      return false
    }
    history.replace(`${supRoute}/home`)
  }

  // 选中页签
  function onClickTabs(
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    info: tabsParam,
  ) {
    e.stopPropagation()
    e.preventDefault()
    switchTab(info)
  }
  function switchTab(info: tabsParam) {
    // 已选中不可跳转
    if (tabsActive === info.url) {
      return false
    }
    history.replace(info.url + info.search)
  }
  // 删除页签
  function oncloseTabs(
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    info: tabsParam,
  ) {
    e.preventDefault()
    e.stopPropagation()
    closeTab(info)
  }
  async function closeTab(info: tabsParam) {
    // 防止undefined导致程序bug
    if (!info) {
      return
    }
    let newurl = ''
    if (tabsData.length === 1) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    if (tabsData.length > 1) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === info.url) {
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = tabsData[param]?.search ? url + tabsData[param].search : url
    }
    // 删除标签 删除 对应路由 删除缓存数据
    dispatch(delTabsAction(info.key))
    dispatch(delRouterAction(info.key))
    dispatch(delModuleDataAction(info.url))
    if (tabsActive === info.url) {
      // 若删除当前激活页签后 需跳转至前一个
      history.replace(newurl)
    }
    // 清除对应的KeepAlive缓存
    await drop(info.key)
  }
  // 清除所有tabs
  async function onClickDelall() {
    history.replace('/srm/home')
    dispatch(resetTabsAction())
    dispatch(resetRouterAction())
    dispatch(resetModuleDataAction())
    dispatch(resetFormDataAction())
    dispatch(setformStateInitAction())
    await clear()
  }
  type MenuName = '关闭' | '关闭其他' | '关闭所有'
  const handleRightMenuClick: MenuProps['onClick'] = async (e) => {
    const currentItem = tabsData.filter((item) => {
      return item.url === tabsActive
    })?.[0]
    // const  res
    switch (e.key) {
      case '关闭':
        closeTab(currentRightTab ?? currentItem)
        break
      case '关闭所有':
        onClickDelall()
        break
      case '关闭其他':
        switchTab(currentRightTab ?? currentItem)
        dispatch(delOtherTabsAction(currentRightTab?.key ?? ''))
        tabsData.forEach(async (item) => {
          if (currentRightTab?.key !== item.key) {
            dispatch(delModuleDataAction(item.url))
            // 清除对应的KeepAlive缓存
            await drop(item.key)
          }
        })
        break
    }
  }
  const menulist: MenuName[] = ['关闭', '关闭其他', '关闭所有']

  const items = menulist.map((item) => ({
    label: item,
    key: item,
  }))

  function handleRightMenuChange(info: tabsParam) {
    dispatch(setCurrentRightTabAction(info))
  }
  return (
    <div className={Style.tabContainer}>
      <div
        className={`${Style.tabsHome} ${
          tabsActive === '/srm/home' ? Style.tabActive : ''
        }`}
        onClick={onClickHome}
      >
        {/* <img style={{width: '20px',height: '20px'}} src={logoOn} alt='' /> */}
        <span>工作台</span>
      </div>
      <div
        className={Style.tabsBox}
        ref={ref}
        onWheel={onWheel}
        onScroll={onScroll}
      >
        {tabsData.map((item, index) => (
          <Dropdown
            key={item.key}
            menu={{
              items,
              onClick: handleRightMenuClick,
            }}
            trigger={['contextMenu']}
            placement="bottomLeft"
            getPopupContainer={() => document.body}
            onOpenChange={(visible) => {
              if (visible) {
                handleRightMenuChange(item)
              }
            }}
          >
            <div key={item.key}>
              {index !== 0 ? (
                <Divider
                  type="vertical"
                  style={{ backgroundColor: '#ffffff', opacity: 0.2 }}
                />
              ) : null}
              <div
                className={`${Style.tabItem} ${
                  tabsActive === item.url ? Style.tabActive : ''
                }`}
                onClick={(e) => onClickTabs(e, item)}
                ref={tabsActive === item.key ? itemRef : null}
              >
                <div className={Style['tabItem-inner']}>
                  {item.title}
                  <CloseOutlined
                    className={Style.icon}
                    onClick={(e) => oncloseTabs(e, item)}
                  />
                </div>
              </div>
            </div>
          </Dropdown>
        ))}
      </div>
      {tabsData.length > 0 ? (
        <div className={Style.tabsTool} onClick={onClickDelall}>
          清除
        </div>
      ) : null}
    </div>
  )
}

export default Customtabs
